import {EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class AnimationService {

  emitCurrentDirection: EventEmitter<Object> = new EventEmitter<Object>();
  routing: string;

  constructor(private _router: Router) {
  }

  animationDirection() {
    return this.routing;
  }

  routingService(direction, nextRoute) {
    this.routing = direction;
    this.emitCurrentDirection.emit(this.routing);
    setTimeout(() => {
      this._router.navigateByUrl(nextRoute).then();
    });
  }

  mobileRoutingSerivce(event, nextRoute) {
    const panToDirection = {
      'panright': 'backward',
      'panleft': 'forward',
      'panup': 'upward',
      'pandown': 'downward'
    };
    const direction = panToDirection[event.additionalEvent];
    this.routingService(direction, nextRoute);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/_animations/animations.service.ts